import { useEffect, useState } from 'react';
import './section-custom.less';
import { Input, message, Image, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { PSection, ParamIn } from '@/commons/interface/speccommon/section';
import { addCustomSection, } from '@/api/spec-common/section';
import { SectionType, getSectionInfo, getSectionTypeItemInfo, getSectionTypeItemList } from '@/commons/enums/speccommon/section';
import { ReactComponent as ArrowDownSvg } from '@/commons/icons/arrow/arrow-down-black.svg';
import ContextMenuWrapper from '@/commons/widget/context-menu/context-menu-wrapper';
import { ParamUnits, convertToSuperscript } from '@/commons/utils/unit';
import { floatVerification } from '@/commons/utils/antd-input';
import SingleSelect from '@/commons/widget/select/single-select';


interface IProps {
    sections: PSection[]
    paramIns: ParamIn[]
    goBack: (mode: string) => void
    width: number
}

export default function SectionCustom(props: IProps, ref) {

    const { projectUuid } = useParams();
    const [btnLoading, setBtnLoading] = useState<boolean>(false);
    const [groupVisiable, setGroupVisiable] = useState<boolean>(false);
    const [typeVisiable, setTypeVisiable] = useState<boolean>(false);
    const [sectionGroup, setSectionGroup] = useState<any>(getSectionInfo("1")); // 选中的组
    const [sectionType, setSectionType] = useState<any>(getSectionTypeItemInfo("1")); // 选中的类型
    const [data, setData] = useState<ParamIn>(null);
    const [newSection, setNewSection] = useState<PSection>({});
    const [nameStr, setNameStr] = useState<string>('');

    useEffect(() => {
        setNewSection({});
        setNameStr("");
        let data: ParamIn = props.paramIns?.find(item => item.id === sectionType?.key)
        setData(data);
    }, [sectionType])

    const handleGroupSelect = (key: string, label: string) => {
        let section = getSectionInfo(key);
        setSectionGroup(getSectionInfo(section.key));
        setSectionType(getSectionTypeItemInfo(section.item[0].toString()));
        setGroupVisiable(false);
    }

    const handleTypeSelect = (key: string, label: string) => {
        setSectionType(getSectionTypeItemInfo(key));
        setTypeVisiable(false);
    }

    const paramInChange = (value: string, field: string) => {
        let newV = { ...newSection };
        newV[field] = value;
        setNewSection(newV);
    }

    const paramInBlur = (field: string) => {
        let newS = { ...newSection };
        let newV = newS[field];
        if(typeof newV === 'number'){
            newV = newV.toString();
        }
        let formatValue = floatVerification(newV);
        newS[field] = formatValue;
        setNewSection(newS);
    }

    const handleInsert = () => {
        if (!nameStr) {
            message.warning("参数不完整");
            return;
        }
        let flag = false;
        data?.paramIn?.forEach(item => {
            if (!newSection[item]) {
                flag = true;
            }
        })
        if (flag) {
            message.warning("参数不完整");
            return;
        }
        let par: PSection = {
            name: nameStr,
            type: sectionType?.key,
            paramIn: JSON.parse(JSON.stringify(newSection)),
            projectUuid: projectUuid,
            isSelfDefine: true,
        }
        setBtnLoading(true);
        addCustomSection(projectUuid, par).then(res => {
            if (res.status === 200) {
                message.success("添加成功");
                props.goBack('lib');
            }
        }).catch(err => {
            message.error("添加失败");
        }).finally(() => {
            setNewSection({});
            setNameStr("");
            setBtnLoading(false);
        })
    }

    return (
        <div className='section-custom-panel'>
            <div className='select-wrapper'>
                <ContextMenuWrapper
                    container={
                        <div className="sss-content" onClick={() => { }} style={{ width: props.width - 32 - 2 }}>
                            <div className="text elliepis">{sectionGroup?.label}</div>
                            <ArrowDownSvg className='arrow' />
                        </div>
                    }
                    classname='select-area'
                    width={props.width - 32 - 2}
                    visible={groupVisiable}
                    onVisibleChange={(v) => setGroupVisiable(v)}
                >
                    <SingleSelect
                        width={props.width - 32 - 2}
                        options={SectionType}
                        selectedKey='key'
                        handleSelectItem={(a, b) => handleGroupSelect(a, b)}
                    />
                </ContextMenuWrapper>
            </div>
            <div className='select-wrapper'>
                <ContextMenuWrapper
                    container={
                        <div className="sss-content" onClick={() => { }} style={{ width: props.width - 32 - 2 }}>
                            <Image className='thumbnail' width={16} height={16} preview={false} src={getSectionTypeItemInfo(sectionType?.key)?.thumbnail} />
                            <div className="type elliepis">{sectionType?.label}</div>
                            <ArrowDownSvg className='arrow' />
                        </div>
                    }
                    classname='select-area'
                    width={props.width - 32 - 2}
                    visible={typeVisiable}
                    onVisibleChange={(v) => setTypeVisiable(v)}
                >
                    <SingleSelect
                        width={props.width - 32 - 2}
                        options={getSectionTypeItemList(sectionGroup?.key)}
                        selectedKey='key'
                        handleSelectItem={(a, b) => handleTypeSelect(a, b)}
                    />
                </ContextMenuWrapper>
            </div>
            <div className='img-area'>
                <Image
                    width={200}
                    height={200}
                    src={getSectionTypeItemInfo(sectionType?.key)?.image}
                    preview={false}
                />
            </div>
            <div className='message-area'>
                <div className='message' style={{ width: props.width - 32 - 2 }}>
                    <div className='param-name'>名称</div>
                    <div className='value'>
                        <Input
                            value={nameStr}
                            onChange={(e) => setNameStr(e.target.value)}
                        />
                    </div>
                </div>
                {data?.paramIn?.map((item, idx) => (
                    <div key={idx} className='message' style={{ width: props.width - 32 - 2 }}>
                        <div className='param-name'>{item}</div>
                        <div className='value'>
                            <Input
                                value={newSection[item]}
                                onChange={(e) => paramInChange(e.target.value, item)}
                                onBlur={() => paramInBlur(item)}
                            />
                        </div>
                        <div className='unit' dangerouslySetInnerHTML={{ __html: convertToSuperscript(ParamUnits[item]) }} />
                    </div>
                ))}
            </div>
            <div className='footer'>
                <Button className='btn' onClick={handleInsert} loading={btnLoading}>添加</Button>
                <Button className='btn cancel' onClick={() => { props.goBack('lib'); }}>取消</Button>
            </div>
        </div>

    )
}